import { useLocation, useNavigate } from 'react-router-dom'
import { CircleDot, CheckCircle2, Calendar } from 'lucide-react'
import { hapticSelection } from '../lib/telegram'

const TABS = [
  { id: '/',         label: 'Активные',  Icon: CircleDot },
  { id: '/done',     label: 'Готово',    Icon: CheckCircle2 },
  { id: '/calendar', label: 'Календарь', Icon: Calendar },
] as const

export default function TabBarDriver() {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const matchTab = (id: string) => id === '/' ? pathname === '/' : pathname.startsWith(id)

  return (
    <nav className="tabbar">
      {TABS.map(({ id, label, Icon }) => {
        const active = matchTab(id)
        return (
          <button
            key={id}
            className={`tabbar-item${active ? ' is-active' : ''}`}
            onClick={() => { if (!active) hapticSelection(); navigate(id) }}
          >
            <Icon />
            <span>{label}</span>
          </button>
        )
      })}
    </nav>
  )
}
